import { createContext, useContext } from "react";

interface CommandMenuControls {
  readonly open: () => void;
}

// A no-op by default rather than a throwing guard: with the unified sidebar off there is no menu to
// open, and the sidebar button and inbox list call this on every route either way.
export const CommandMenuContext = createContext<CommandMenuControls>({ open: () => {} });

export const useCommandMenu = (): CommandMenuControls => useContext(CommandMenuContext);
